module.exports = __webpack_public_path__ + "static/media/img-small-1@2x.1e4f0395.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/img-small-1@2x.png
// module id = 230
// module chunks = 0